export default __webpack_public_path__ + "static/media/3536 spice rack C side.db4246e2.png";